import { IAiImgRequest, IAiImgResponse } from './types';
import {
    FETCH_DATA_REQUEST,
    FETCH_DATA_SUCCESS,
    FETCH_DATA_ERROR,
    SET_DATA_AI_CHEF,
    SELECT_INGREDIENT,
    UPDATE_REQUEST_TYPE,
    RESET,
} from './actions';

export interface DataState {
    params: IAiImgRequest,
    data: IAiImgResponse;
    loading: boolean;
    error: Error | null;
    selectedIngredients: any[];
}

const initialState: DataState = {
    params: {
        url: ''
    },
    data: {} as IAiImgResponse,
    loading: true,
    error: null,
    selectedIngredients: [] as any[],
};

const authReducer = (
    state: DataState = initialState,
    action: any,
): DataState => {
    switch (action.type) {
        case FETCH_DATA_REQUEST:
            return {
                ...state,
                params: action.payload,
                loading: true,
                data: {} as IAiImgResponse,
                error: null,
            };
        case FETCH_DATA_SUCCESS:
            return {
                ...state,
                data: action.payload,
                loading: false,
                error: null,
            };
        case FETCH_DATA_ERROR:
            return {
                ...state,
                loading: false,
                error: action.payload,
            };
        case SET_DATA_AI_CHEF:
            return {
                ...state,
                data: action.payload.data,
                params: action.payload.params,
                selectedIngredients: [],
                loading: false,
                error: null,
            };
        case SELECT_INGREDIENT:
            return {
                ...state,
                selectedIngredients: action.payload,
            };
        case UPDATE_REQUEST_TYPE:
            return state;
        case RESET:
            return {
                ...initialState,
                params: {
                    url: !action.payload ? state.params.url : '',
                },
            };
        default:
            return state;
    }
};

export default authReducer
